import React, { useState } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import "../../../style/ModalForm.css"

const UserModal = ({ show, onHide, onSave, formData, handleInputChange, currentUser, tenants }) => {
    const [error, setError] = useState("");

    const handleSave = () => {
        if (!formData.email.trim()) {
            setError("Email is required.");
            return;
        }
        if (!formData.tenantId || parseInt(formData.tenantId) === 0) {
            setError("Tenant is required.");
            return;
        }
        setError(""); // Clear any previous errors
        onSave();
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="custom-modal">
            <Modal.Header closeButton>
                <Modal.Title>{currentUser ? "Edit User" : "Add User"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={formData.email || ''}
                            onChange={handleInputChange}
                            onBlur={handleInputChange}
                            placeholder="Enter user email (unique identifier)"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Tenant</Form.Label>
                        <Form.Control
                            as="select"
                            name="tenantId"
                            value={(!!formData.tenantId) ? formData.tenantId : 0}
                            onBlur={handleInputChange}
                            onChange={handleInputChange}
                        >
                            <option value="">Select a tenant</option>
                            {tenants.map((tenant) => (
                                <option key={tenant.id} value={tenant.id}>
                                    {tenant.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserModal;